import { EVA_OFFER_COMPANY_IDS } from "../constants/evaluationOfferCompanies.js";
export function isValidCompanyForInterimOfferTab(companyId) {
  return companyId !== undefined && EVA_OFFER_COMPANY_IDS.includes(companyId);
}